'use client';

import { usePathname } from 'next/navigation';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

export function BreadcrumbNav() {
  const pathname = usePathname();

  // Generate breadcrumbs based on current path
  const generateBreadcrumbs = () => {
    const pathSegments = pathname.split('/').filter(Boolean);

    // Always start with Home
    const breadcrumbs: Array<{
      label: string;
      href: string;
      isCurrentPage?: boolean;
    }> = [{ label: 'Home', href: '/' }];

    // Handle different routes
    if (pathSegments.length === 0) {
      // We're on the home page
      return [{ label: 'Home', href: '/', isCurrentPage: true }];
    }

    // Handle projects route
    if (pathSegments[0] === 'projects') {
      breadcrumbs.push({ label: 'Projects', href: '/projects' });

      if (pathSegments.length === 1) {
        // We're on the projects page
        breadcrumbs[breadcrumbs.length - 1].isCurrentPage = true;
      }
    }

    // Handle project detail route
    if (pathSegments[0] === 'project' && pathSegments[1]) {
      const projectId = pathSegments[1];
      // TODO
      // @ts-ignore
      const project = [].find((p) => p.id === projectId);

      breadcrumbs.push({ label: 'Projects', href: '/projects' });
      breadcrumbs.push({
        // @ts-ignore
        label: project?.name || 'Project',
        href: `/project/${projectId}`,
        isCurrentPage: true,
      });
    }

    // Handle meetings route
    if (pathSegments[0] === 'meetings') {
      breadcrumbs.push({ label: 'Meetings', href: '/meetings' });

      if (pathSegments.length === 1) {
        breadcrumbs[breadcrumbs.length - 1].isCurrentPage = true;
      }
    }

    // Handle settings route
    if (pathSegments[0] === 'settings') {
      breadcrumbs.push({ label: 'Settings', href: '/settings' });

      if (pathSegments.length === 1) {
        breadcrumbs[breadcrumbs.length - 1].isCurrentPage = true;
      }
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Don't show breadcrumbs on home page
  if (pathname === '/') {
    return null;
  }

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {breadcrumbs.map((breadcrumb, index) => (
          <div key={breadcrumb.href} className="flex items-center">
            {index > 0 && <BreadcrumbSeparator />}
            <BreadcrumbItem>
              {breadcrumb.isCurrentPage ? (
                <BreadcrumbPage>{breadcrumb.label}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink href={breadcrumb.href}>
                  {breadcrumb.label}
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </div>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
